import { create } from 'zustand';

/** Open/close state for the rich entity detail modal (keyed by entity uid). */
interface DetailModalState {
  /** UID of the entity whose detail modal is open, or null. */
  openUid: string | null;
  /** Open the detail modal for an entity. */
  open: (uid: string) => void;
  /** Close the detail modal. */
  close: () => void;
}

/** Store controlling the entity detail modal. */
export const useDetailModalStore = create<DetailModalState>((set) => ({
  openUid: null,
  open: (uid) => set({ openUid: uid }),
  close: () => set({ openUid: null }),
}));
